export default "__VITE_ASSET__5b8bfe05__"